var template = require('./profile_link_partner.html.slim')
declare var angular

export class ProfileLinkSpouseController {
  static $inject = ['Spouse', '$location', 'brand']

  email: string;
  secret: string;
  token: string;
  errorMessage: string;
  brandFullName: string;
  errors;
  spouse;

  constructor(
    private Spouse,
    private $location,
    private brand
  ) {
    this.brandFullName = this.brand.getBrandFullName();
    Spouse.get({ token: $location.search().token }).$promise.then(
      (spouse) => { this.spouse = spouse },
      (error) => { this.processErrors(error) }
    )
  }

  sendInvitation() {
    this.Spouse.create({
      email: this.email,
      secret: this.secret,
    }).$promise.then(
      (spouse) => { this.spouse = spouse },
      (error) => { this.processErrors(error) }
    )
  }

  link() {
    this.errorMessage = null
    this.Spouse.update({
      token: this.$location.search().token,
      secret: this.secret,
    }).$promise.then(
      (spouse) => {
        this.spouse = spouse
      },
      (error) => {
        this.errorMessage = 'Incorrect phrase'
      }
    )

  }

  unlink() {
     this.spouse = this.Spouse.delete()
     this.errorMessage = null
  }

  private processErrors(error) {
    this.errorMessage = ""
    this.errors = error.data.errors
    Object.keys(this.errors).forEach((value) => {
      this.errorMessage += this.errors[value] + " "
    })
  }

}
angular.module('wbComponents')
  .controller("ProfileLinkPartnerController", ProfileLinkSpouseController)
  .directive('profileLinkPartner', function() {
    return {
      restrict: 'E',
      templateUrl: template,
      controller: "ProfileLinkPartnerController",
      controllerAs: 'ctrl',
      replace: true,
    }
  });
